import { render } from "./Training.vue?vue&type=template&id=04acaeb2&scoped=true"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"

import "./Training.vue?vue&type=style&index=0&id=04acaeb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04acaeb2"

export default script